import axios from "axios";
import axiosThrottle from "axios-request-throttle";
import queryString from "query-string";

export const apiClient = axios.create({
	withCredentials: true,
	withXSRFToken: true,
	baseURL: import.meta.env.VITE_PUBLIC_API_BASE_URL || "http://localhost:8000/api/",
	paramsSerializer: {
		serialize(params) {
			return queryString.stringify(params, { arrayFormat: "bracket" });
		},
	},
	timeout: 1000 * 600,
});

axiosThrottle.use(apiClient, { requestsPerSecond: 50 });

// Add response interceptor to handle session termination and expiration
apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		// Check if the error is due to session termination or expiration
		if (error.response?.status === 401) {
			const message = error.response?.data?.message;
			const errorType = error.response?.data?.error;

			// biome-ignore lint/complexity/useOptionalChain: <explanation>
			if (message?.includes("session has been terminated") || (message && message.includes("Session expired")) || errorType === "session_expired") {
				// Clear auth state and redirect to login
				localStorage.removeItem("auth.token");
				window.location.href = "/login";
			}
		}
		return Promise.reject(error);
	},
);
